// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 10px 0px;
}
.wrapper::-webkit-scrollbar {
  display: none;
}
@media (min-width: 991px) {
  .wrapper {
    justify-content: center;
  }
}

.slide {
  display: flex;
  align-items: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.category-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
@media (min-width: 991px) {
  .category-wrapper {
    min-width: -moz-fit-content;
    min-width: fit-content;
  }
}
.category-wrapper ion-chip {
  border-radius: 50%;
  padding: 5px;
  background: white;
  flex: 0 0 auto;
  height: 60px;
  width: 60px;
  margin: 0px;
  padding: 0px;
  position: relative;
}
@media (min-width: 991px) {
  .category-wrapper ion-chip {
    height: 70px;
    width: 70px;
  }
}
.category-wrapper ion-chip .category-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
}
.category-wrapper ion-chip .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
}
@media (min-width: 991px) {
  .category-wrapper ion-chip .border-dotted {
    height: 65px;
    width: 65px;
  }
}

.line-dotted-block {
  min-width: 20px;
  height: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .line-dotted-block {
    height: 112px;
    min-width: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-skeleton-categories/menu-skeleton-categories.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACC,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;AAFD;AAIC;EACC,aAAA;AAFF;ACTE;EDEF;IAaE,uBAAA;EAFA;AACF;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;AAFD;;AAKA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sBAAA;AAFD;AC3BE;EDyBF;IAOE,2BAAA;IAAA,sBAAA;EADA;AACF;AAGC;EACC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AADF;AC3CE;EDmCD;IAYE,YAAA;IACA,WAAA;EAAD;AACF;AAEE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;AAAH;AAGE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;AADH;ACjEE;ED4DA;IASE,YAAA;IACA,WAAA;EAAF;AACF;;AAKA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFD;AC/EE;ED4EF;IAQE,aAAA;IACA,eAAA;EADA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n// Match the category layout from menu.page.scss and scrolling-categories\n.wrapper {\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n\tpadding: 10px 0px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t@include desktop {\n\t\tjustify-content: center;\n\t}\n}\n\n.slide {\n\tdisplay: flex;\n\talign-items: center;\n\tmin-width: fit-content;\n}\n\n.category-wrapper {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tmin-width: fit-content;\n\n\t@include desktop {\n\t\tmin-width: fit-content;\n\t}\n\n\tion-chip {\n\t\tborder-radius: 50%;\n\t\tpadding: 5px;\n\t\tbackground: white;\n\t\tflex: 0 0 auto;\n\t\theight: 60px;\n\t\twidth: 60px;\n\t\tmargin: 0px;\n\t\tpadding: 0px;\n\t\tposition: relative;\n\n\t\t@include desktop {\n\t\t\theight: 70px;\n\t\t\twidth: 70px;\n\t\t}\n\n\t\t.category-image {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\twidth: 80%;\n\t\t\theight: 80%;\n\t\t}\n\n\t\t.border-dotted {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\twidth: 58px;\n\t\t\theight: 58px;\n\n\t\t\t@include desktop {\n\t\t\t\theight: 65px;\n\t\t\t\twidth: 65px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.line-dotted-block {\n\tmin-width: 20px;\n\theight: 63px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t@include desktop {\n\t\theight: 112px;\n\t\tmin-width: 50px;\n\t}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
